import ReportsPage from "components/Reports/Pages/Reports";

function ClinicReports() {
    return (
        <>
            <ReportsPage userType={2} />
        </>
    )
}

export default ClinicReports;
